/** iOS LinkMe 首装：deferred 可能晚于首次 pull，与原生补投 2/5/15/30/60s 对齐。 */
export const IOS_DEFERRED_DEEP_LINK_PULL_DELAYS_MS = [
  0, 2000, 5000, 15000, 30000, 60000,
] as const;

/** iOS 分段 pull；Android / 其他平台单次 pull 即可。 */
export function getDeferredDeepLinkPullDelaysMs(platform: string): number[] {
  return platform === "ios" ? [...IOS_DEFERRED_DEEP_LINK_PULL_DELAYS_MS] : [0];
}
